module.exports = __webpack_public_path__ + "static/media/bg_succes.bc59723e.svg";